import isArray from 'lodash/isArray';
import isArrayLike from 'lodash/isArrayLike';
import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';
import partition from 'lodash/partition';
import pick from 'lodash/pick';

const toArray = (value) => {
  if (isNil(value)) {
    return [];
  }

  if (isArray(value)) {
    return value;
  }

  return [value];
};

const convertToCommonArray = (arrayLike) => {
  if (isArray(arrayLike) || !arrayLike) {
    return arrayLike;
  }

  if (isArrayLike(arrayLike)) {
    return [...arrayLike];
  }

  throw Error('Array is not an array instance');
};

export { isEmpty, isNil, partition, pick, toArray, convertToCommonArray };
